// extracted by mini-css-extract-plugin
export var fullGrid = "_2h-3";
export var pdpPreviewContainer = "_2h-1";
export var previewContainer = "_2h-0";
export var togglePreviewContainer = "_2h-2";